export default "__VITE_ASSET__sKxIhujH__"